import { Controller } from "stimulus"

export default class extends Controller {
  static values = { source: String }

  copy() {
    const source = document.getElementById(this.sourceValue)
    if (!source) return

    const html = source.innerHTML
    const text = source.innerText

    if (navigator.clipboard && window.ClipboardItem) {
      const blob = new Blob([html], { type: "text/html" })
      const textBlob = new Blob([text], { type: "text/plain" })

      navigator.clipboard.write([
        new ClipboardItem({
          "text/html": blob,
          "text/plain": textBlob,
        })
      ]).then(() => this.showCopied())
    } else {
      const listener = (e) => {
        e.preventDefault()
        e.clipboardData.setData("text/html", html)
        e.clipboardData.setData("text/plain", text)
      }
      document.addEventListener("copy", listener)
      document.execCommand("copy")
      document.removeEventListener("copy", listener)
      this.showCopied()
    }
  }

  showCopied() {
    const original = this.element.textContent
    this.element.textContent = "Copied!"
    setTimeout(() => { this.element.textContent = original }, 2000)
  }
}
